import { isWeapon } from "@ghostland/shared";

/**
 * Client mirror of the LOCAL player's equipped weapons (first/second hand). Fed from the local
 * player's synced schema (Player.hand1 / hand2) in world3d; the inventory paperdoll, the combat
 * toggle, and the J button indicator all subscribe. "" = empty hand.
 */
export interface Hands {
  hand1: string;
  hand2: string;
  /** Bait loaded in the equipped rod (0 unless hand1 is the fishing rod). */
  rodBait: number;
}

type Listener = (h: Hands) => void;

class WeaponStore {
  private hands: Hands = { hand1: "", hand2: "", rodBait: 0 };
  private readonly listeners = new Set<Listener>();

  get(): Hands { return this.hands; }

  /** True if either hand holds an actual WEAPON (gates combat mode + the J indicator + the Kapon
   *  gate). Tools like the fishing rod occupy a hand but don't count. */
  hasWeapon(): boolean { return isWeapon(this.hands.hand1) || isWeapon(this.hands.hand2); }

  set(h: Hands): void {
    if (h.hand1 === this.hands.hand1 && h.hand2 === this.hands.hand2 && h.rodBait === this.hands.rodBait) return;
    this.hands = h;
    for (const fn of this.listeners) fn(this.hands);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.hands);
    return () => this.listeners.delete(fn);
  }
}

export const weaponStore = new WeaponStore();
